import { render } from "./SideMenuLeft.vue?vue&type=template&id=2a929129&scoped=true&ts=true"
import script from "./SideMenuLeft.vue?vue&type=script&lang=ts"
export * from "./SideMenuLeft.vue?vue&type=script&lang=ts"

import "./SideMenuLeft.vue?vue&type=style&index=0&id=2a929129&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a929129"]])

export default __exports__